import { Button } from "react-bootstrap";
import { Link } from "react-router";

export default function CancelButton({ to, className }) {
    return (
        <Button
            variant="outline-secondary"
            as={Link}
            to={to}
            className={className}
        >
            Cancel
        </Button>
    );
}
